import {
    DocumentUploadEntry,
    Question,
    UploadedDocumentContent,
} from '../../../types/question'

export interface Option {
    title: string
    content: string
    index: number
}

export interface SelectType {
    multiple?: boolean
    options: Option[]
    default?: string
    placeholder?: string
    allowed_answer_type?: string
}

// Resposta da célula quando o usuário marca "Não se aplica" numa coluna
// `optional` (mesmo texto do backend).
export const NOT_APPLICABLE = 'Não se aplica'

export interface tableType {
    headers: Array<{
        name: string
        label: string
        size?: number
        optional?: boolean
    }>
    items?: Array<{
        label: string
        placeholder: string
        allowed_answer_type: string
    }>
    type?: string
}

export interface RadioType {
    options: Option[]
}

export interface DocumentUploadType {
    documents: DocumentUploadEntry[]
    // false: arquivo so responde o formulario (try-get-answers); nao substitui
    // documento nem entra na geracao. Ausente = true.
    use_as_context?: boolean
}

export interface QuestionType extends Omit<Question, 'type'> {
    type: {
        text?: boolean
        radio?: RadioType
        select?: SelectType
        table?: tableType
        checkbox?: boolean
        multiselect?: SelectType
        document_upload?: DocumentUploadType
    }
    question_type:
        | 'text'
        | 'radio'
        | 'select'
        | 'table'
        | 'checkbox'
        | 'multiselect'
        | 'document_upload'
    optional: boolean
}

export interface RowData {
    id: number
    [key: string]: any
}

export type FormDataValue =
    | string
    | boolean
    | string[]
    | {[key: string]: string | boolean}
    | UploadedDocumentContent[]

export interface FormData {
    [key: string]: FormDataValue
}

export type {UploadedDocumentContent}
